(() => {
  const navigationKey = 'jugnu-internal-navigation';
  let internalNavigation = false;
  try {
    const pending = JSON.parse(sessionStorage.getItem(navigationKey) || 'null');
    sessionStorage.removeItem(navigationKey);
    internalNavigation = Boolean(pending && pending.url === location.href && Date.now() - pending.time < 30000);
  } catch (_) { /* Referrer detection still works when storage is unavailable. */ }

  // Remember internal links even when a browser omits the referrer.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.hasAttribute('download')) return;
    if (link.target && link.target !== '_self') return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || (url.pathname === location.pathname && url.search === location.search)) return;
    try {
      sessionStorage.setItem(navigationKey, JSON.stringify({ url: url.href, time: Date.now() }));
    } catch (_) { /* Storage may be disabled. */ }
  });

  const popup = document.querySelector('[data-entry-image-popup]');
  if (!popup || window.Shopify?.designMode) return;
  const navigation = performance.getEntriesByType('navigation')[0];
  if (navigation && navigation.type !== 'navigate') return;
  let internalReferrer = false;
  try {
    internalReferrer = Boolean(document.referrer && new URL(document.referrer).origin === location.origin);
  } catch (_) { /* An invalid referrer is treated as a direct visit. */ }
  if (internalNavigation || internalReferrer) return;

  const previousFocus = document.activeElement;
  const closeButton = popup.querySelector('button');
  let timer;
  closeButton.addEventListener('click', () => popup.close());
  popup.addEventListener('close', () => {
    clearTimeout(timer);
    if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
  });
  popup.showModal();
  timer = setTimeout(() => popup.close(), 5000);
})();
